import React from 'react';

const NotificationWarningIcon = ({ size = 20 }) => {
  return (
    <svg t="1601056467438" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14940" width={size} height={size}>
      <path
        d="M554.666667 597.333333 469.333333 597.333333 469.333333 426.666667 554.666667 426.666667M554.666667 768 469.333333 768 469.333333 682.666667 554.666667 682.666667M42.666667 896 981.333333 896 512 85.333333 42.666667 896Z"
        p-id="14941"
        fill="#EDC92C"
       />
    </svg>
  );
};

export default NotificationWarningIcon;
